import React from 'react';
import ContactForm from '../components/ContactForm'; // Importamos el formulario
import './Contacto.css';

function Contacto() {
    return (
        <div className="contacto">
            <title>Contacto | DanPauleX</title>
            <link rel="canonical" href="https://danpaulex.com/contacto" />
            <meta
                name="description"
                content="Solicita presupuesto a DanPaulex: rellena el formulario de contacto o escríbenos a contacto@danpaulex.com."
            />

            <h1 className="visualmente-oculto">Contacto</h1>

            {/* Contenedor para organizar ContactForm y Contact Info en horizontal */}
            <div className="contacto-container">
                <ContactForm />
            </div>
        </div>
    );
}

export default Contacto;
